// extracted by mini-css-extract-plugin
module.exports = {"MasterData":"MasterData_MasterData__2c_GA","Button":"MasterData_Button__1ZhqT","HeaderButtonRowRight":"MasterData_HeaderButtonRowRight__3_Dim"};